<template>
	<div class="map-wrap">
		<div class="map">
			<div class="map-item" v-for="(item,index) in point" :style="{ top: item.y + 'rem', left: item.x + 'rem' }">
				<div class="map-level">{{item.level}}级</div>
				<div class="map-msg" :class="item.completeStatus?'act':''">
					<div class="name"><img src="../assets/level.png" />{{item.name}}</div>
					<div class="text">{{item.msg}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {
			point:[
				{
					level:1,
					msg:'暂未设置目标',
					x:50.55,
					y:2.2
				},{
					level:2,
					msg:'暂未设置目标',
					x:39.15,
					y:0.8
				},{
					level:3,
					msg:'暂未设置目标',
					x:30.8,
					y:1.45
				},{
					level:4,
					msg:'暂未设置目标',
					x:23.45,
					y:11.65
				},{
					level:5,
					msg:'暂未设置目标',
					x:12.4,
					y:13.2
				},{
					level:6,
					msg:'暂未设置目标',
					x:2.05,
					y:15.75
				},{
					level:7,
					msg:'暂未设置目标',
					x:6.7,
					y:20.65
				},{
					level:8,
					msg:'暂未设置目标',
					x:14.4,
					y:27.7
				},{
					level:9,
					msg:'暂未设置目标',
					x:19.15,
					y:29.25
				},{
					level:10,
					msg:'暂未设置目标',
					x:26.85,
					y:24.65
				},{
					level:11,
					msg:'暂未设置目标',
					x:32.3,
					y:23.75
				},{
					level:12,
					msg:'暂未设置目标',
					x:37.55,
					y:30
				},{
					level:13,
					msg:'暂未设置目标',
					x:28,
					y:39.8
				},{
					level:14,
					msg:'暂未设置目标',
					x:39.85,
					y:38.85
				},{
					level:15,
					msg:'暂未设置目标',
					x:55.95,
					y:31.2
				},{
					level:16,
					msg:'暂未设置目标',
					x:46.5,
					y:23.6
				},{
					level:17,
					msg:'暂未设置目标',
					x:40.35,
					y:21.45
				},{
					level:18,
					msg:'暂未设置目标',
					x:35.1,
					y:17.45
				},{
					level:19,
					msg:'暂未设置目标',
					x:45.35,
					y:15.3
				},{
					level:20,
					msg:'暂未设置目标',
					x:61.25,
					y:22.25
				},
			],
		}
	},

	created(){
		this.getAchievementList()
	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {
		// 获取成就列表并处理数据
		async getAchievementList() {
		  const res = await this.$api.getAchievementList();
		  if (res.data.success) {
		    // 格式化接口返回的数据并填充到 point 中
				res.data.data.forEach((item, index) => {
				    if (index < this.point.length) { // 确保不超过 point 数组的长度
				        this.point[index].level = index + 1; // 索引值 + 1
				        this.point[index].msg = `完成${item.projectTypeName}${item.learnNum}${item.wayType === 1 ? '分钟' : '次'}`; // 构建 msg
				        this.point[index].completeStatus = item.completeStatus; // 直接赋值
								this.point[index].name = item.name; // 直接赋值
				    }
				});
				
				// 结果是 point 数组，包含更新后的数据
				console.log(this.point);
		  } else {
		    this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
		  }
		},
	}
}
</script>

<style lang="scss" scoped>
.map-wrap{
	padding: 2rem;
	box-sizing: border-box;
}	
.map{
	width: 68.6rem;
	height: 45.95rem;
	background-image: url(../assets/map.png);
	background-repeat: no-repeat;
	background-size: contain;
	position: relative;
	.map-item{
		position: absolute;
		z-index: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		&:hover{
			z-index: 2;
		}
		.map-level{
			width: 2.3rem;
			height: 2.3rem;
			background: #FF9D55;
			box-shadow: 0rem 0.2rem 0.2rem 0rem rgba(0,0,0,0.25);
			border-radius: 49.95rem 49.95rem 49.95rem 49.95rem;
			border: 0.2rem solid #FFFFFF;
			margin-bottom: 0.65rem;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: bold;
			font-size: 1rem;
			color: #FFFFFF;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.map-msg{
			padding: 0.5rem;
			background: #FFFFFF;
			box-shadow: 0rem 0.1rem 0.4rem 0rem rgba(99,99,99,0.2);
			border-radius: 1.15rem 1.15rem 1.15rem 1.15rem;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 0.8rem;
			color: #000000;
			display: flex;
			flex-direction: column;
			align-items: center;
			.name{
				display: flex;
				align-items: center;
				img{
					width: 16px;
					height: 16px;
				}
			}
		}
		.act{
			background-color: #642d71;
			color: #fff;
		}
	}
}
</style>